import React, { useState, Fragment } from 'react';
import {
  IconButton,
  Grid,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Popper,
  TableSortLabel,
  NativeSelect,
  ClickAwayListener,
  Checkbox,
} from '@material-ui/core';
import { StylesProvider, withStyles } from '@material-ui/core/styles';
import Icon from '@mdi/react';
import {
  mdiDotsVertical,
  mdiArrowDown,
  mdiArrowUp,
  mdiCloseCircleOutline,
} from '@mdi/js';

import RenderFilter from './tableListDaynamicFilter';
import {
  removeEmptyValueObject,
} from './helpers';
// import RenderFilter from './tableListDaynamicFilterHookForm';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';


const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontSize: 12,
      whiteSpace: 'nowrap',
      // overflow: 'hidden',
      textOverflow: 'ellipsis',
      // '@media (max-width: 768px)': {
      //   fontSize: 10,
      // },
    },
    body: {
      fontSize: 14,
      // whiteSpace: 'nowrap',
      // overflow: 'hidden',
      // textOverflow: 'ellipsis',
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    icon: {
      margin: 'auto 10px auto 0px',
    },
    red: {
      color: 'red'
    },
    columnText: {
      padding: '0 20px 0 0',
      color: 'white',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    optionsMenu: {
      // borderRadius: '50x',
      // padding: '5px 5px !important',
      // backgroundColor: 'red !important',
      // outline: 'none',
      // '-webkit-appearance': 'none !important' /* Safari and Chrome */,
      // '-moz-appearance': 'none !important' /* Firefox */,
      // '&:hover': {
      //   backgroundColor: 'green !important',
      //   color: 'white !important',
      // },
      // cursor: 'pointer !important',
    },
    cancelFilter: {
      borderRadius: '30px',
      backgroundColor: 'red',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const HeaderBuilder = (props: any) => {
  // const authContext = useContext(AuthContext);
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openSize, setOpenSize] = useState<boolean>(false);
  const [searchBy, setSearchBy] = useState<string>('id');
  const [filtersValues, setFiltersValues] = useState({ ...props.filterVal });
  const [type, setType] = useState({ operator: '' });
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterIconShow, setFilterIconShow] = useState({});
  const [selected, setSelected] = React.useState<string[]>([]);

  const removeFilterHandler = (fieldName: any) => {
    const moz = { ...props.filterVal };
    delete moz[fieldName];
    setFiltersValues(moz);
    props.removeFilterHandler(fieldName);
  };
  const searchFilters = () => {
    let filter = { ...props.filterVal };
    delete filter.page;
    delete filter.size;
    delete filter.sort;
    return filter;
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const classes = useStyles();

  // useEffect(() => {
  //   props.setSelectedId(selected);
  // }, [selected]);
  const dateTypeTranslator = (dateType: any) => {
    const status = {
      '=': 'equals',
      '>=': 'greaterThanOrEqual',
      '<=': 'lessThanOrEqual',
      '>': 'greaterThan',
      '<': 'lessThan',
    };
    return status[dateType];
  };
  const selectChangeHandler = (event: any) => {
    if (
      event.target.value == '=' ||
      event.target.value == '>=' ||
      event.target.value == '<=' ||
      event.target.value == '>' ||
      event.target.value == '<'
    ) {
      const val = dateTypeTranslator(event.target.value);
      const name = event.target.name;
      setType({
        ...type,
        [name]: val,
      });
    } else {
      const name = event.target.name;
      setType({
        ...type,
        [name]: event.target.value,
      });
    }
  };
  const handleClickAway = (e: any) => {
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenMenu(false);
  };

  const searchBoxOpen = (prop: any) => (event: React.MouseEvent<unknown>) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSearchBy(prop);
  };

  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      props.onRequestSort(event, property);
    };

  // const handleRequestSort = (
  //   event: React.MouseEvent<unknown>,
  //   property: keyof Data
  // ) => {
  //   const isAsc = orderBy === property && order === 'asc';
  //   setOrder(isAsc ? 'desc' : 'asc');
  //   setOrderBy(property);
  // };
  const isSelected = (id: string) => selected.indexOf(id) !== -1;
  return (
    <StylesProvider injectFirst>
      {/* <Grid container spacing={3}>
        <Grid item xs={12}>
        <TableContainer component={Paper}>
      <Table> */}
      <TableHead>
        <ClickAwayListener onClickAway={handleClickAway}>
          <TableRow>
            {props.firstSpace && <StyledTableCell></StyledTableCell>}
            {props.checkbox && (
              <StyledTableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    props.numSelected > 0 && props.numSelected < props.rowCount
                  }
                  checked={props.rowCount > 0 && props.numSelected === props.rowCount}
                  onChange={props.onSelectAllClick}
                  inputProps={{ 'aria-label': 'select all desserts' }}
                  disableRipple={true}
                  style={{ color: '#fff' }}
                />
              </StyledTableCell>
            )}
            {props?.head.headCells.map((filter: any, index: number) => {
              for (
                let i = 0;
                i < Object.keys(searchFilters()).length;
                i++
              ) {
                const checkFilter = Object.keys(searchFilters())[
                  i
                ].includes(filter.id);
                let findFilter;
                if (checkFilter) {
                  findFilter = Object.keys(filterIconShow).find(
                    filterIcon => {
                      return filterIcon === filter.id;
                    }
                  );
                } else {
                  findFilter = null;
                }
                if (
                  Object.keys(searchFilters())[i].includes(filter.id) &&
                  findFilter == undefined &&
                  checkFilter
                ) {
                  let filtersShuldShow = {
                    ...filterIconShow,
                    [filter.id]: true,
                  };
                  setFilterIconShow(filtersShuldShow);
                }
              }

              return (
                <StyledTableCell
                  key={filter.id}
                  align="center"
                  sortDirection={
                    props.orderBy === filter.id ? props.order : false
                  }
                  data-cy={filter.id}
                >
                  <IconButton onClick={searchBoxOpen(filter.id)}>
                    {' '}
                    <Icon
                      color={
                        filterIconShow[filter.id] ? 'red' : 'secondary'
                      }
                      path={
                        filterIconShow[filter.id]
                          ? mdiCloseCircleOutline
                          : mdiDotsVertical
                      }
                      size={1}
                      className={classes.icon}
                    />{' '}
                  </IconButton>{' '}
                  <TableSortLabel
                    onClick={createSortHandler(filter.id)}
                    direction={
                      props.orderBy === filter.id ? props.order : 'asc'
                    }
                    hideSortIcon={false}
                    style={{ marginLeft: '10px' }}
                    classes={{
                      // Override with the active class if this is the selected column or inactive otherwise
                      icon:
                        props.orderBy === filter.id
                          ? classes.inactiveSortIcon
                          : classes.activeSortIcon,
                    }}
                    IconComponent={() => (
                      <Icon
                        path={
                          props.orderBy === filter.id &&
                            props.order === 'desc'
                            ? mdiArrowUp
                            : mdiArrowDown
                        }
                        size={0.7}
                        className={
                          props.orderBy === filter.id
                            ? classes.activeSortIcon
                            : classes.inactiveSortIcon
                        }
                      />
                    )}
                  >
                    <span className={classes.columnText}>
                      {filter.label}
                    </span>{' '}
                  </TableSortLabel>{' '}
                  {searchBy === filter.id && openMenu ? (
                    <Popper
                      open={openMenu}
                      anchorEl={anchorEl}
                      keepMounted
                      style={{ maxHeight: 48 * 4.5, width: '20ch' }}
                      placement="bottom-end"
                    >
                      <Paper
                        style={{
                          width: '300px',
                          backgroundColor: '#FAECD2',
                        }}
                      >
                        <Grid container style={{ margin: '0px  5px' }}>
                          {searchBy === filter.id && openMenu ? (
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              style={{ margin: '20px 20px 5px 10px' }}
                            >
                              <RenderFilter
                                type={type}
                                filterVals={props.filterVal}
                                filters={[props.head.headCells[index]]}
                                onFilter={(filtervalues: any) => {
                                  setFiltersValues({
                                    ...filtervalues,
                                    page: 0,
                                    size: 10,
                                    sort: props.orderBy + props.order,
                                  });
                                  props.onFilterValue(filtervalues);
                                }}
                              />
                              {/* </div> */}
                            </Grid>
                          ) : null}{' '}
                          <Grid
                            item
                            xs={4}
                            sm={4}
                            style={{ margin: '35px 50px 5px 0px' }}
                          >
                            <NativeSelect
                              value={type.operator}
                              onChange={selectChangeHandler}
                              inputProps={{
                                name: 'operator',
                                id: 'age-native-helper',
                              }}
                              style={{
                                textAlign: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {filter.type == 'date-picker' ? (
                                <Fragment>
                                  <option value="" disabled selected>
                                    {' '}
                                    -- select --
                                  </option>
                                  <option
                                    value="contains"
                                    className={classes.optionsMenu}
                                    disabled
                                  ></option>
                                  <option
                                    value="greaterThanOrEqual"
                                    className={classes.optionsMenu}
                                  >
                                    {'=<'}
                                  </option>
                                  <option
                                    value="lessThanOrEqual"
                                    className={classes.optionsMenu}
                                  >
                                    {'=>'}
                                  </option>
                                  <option
                                    value="lessThan"
                                    className={classes.optionsMenu}
                                  >
                                    {'<'}
                                  </option>
                                  <option
                                    value="greaterThan"
                                    className={classes.optionsMenu}
                                  >
                                    {'>'}
                                  </option>
                                  <option
                                    className={classes.optionsMenu}
                                    value="equals"
                                  >
                                    =
                                  </option>
                                </Fragment>
                              ) : filter.type == 'checkbox' ? (
                                <Fragment>
                                  <option value="" disabled selected>
                                    {' '}
                                    -- select --
                                  </option>
                                  <option
                                    value="in"
                                    className={classes.optionsMenu}
                                  >
                                    in
                                  </option>
                                  <option
                                    className={classes.optionsMenu}
                                    disabled={
                                      props.head.headCells[index]
                                        .type != 'checkbox'
                                    }
                                    value="notIn"
                                  >
                                    notIn
                                  </option>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <option
                                    value=""
                                    disabled
                                    selected
                                    style={{
                                      textAlign: 'center',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      marginRight: '50px',
                                    }}
                                  >
                                    {' '}
                                    -- select --
                                  </option>
                                  <option
                                    value="contains"
                                    className={classes.optionsMenu}
                                  >
                                    contains
                                  </option>
                                  <option
                                    className={classes.optionsMenu}
                                    disabled={
                                      props.head.headCells[index]
                                        .type != 'input'
                                    }
                                    value="equals"
                                  >
                                    equals
                                  </option>
                                </Fragment>
                              )}
                            </NativeSelect>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          alignItems="center"
                          justify="space-around"
                          direction="column"
                        >
                          {Object.entries(searchFilters()).map(
                            (searchFilter, sizess) => {
                              return (
                                searchFilter[0].includes(filter.id) && (
                                  <Grid item>
                                    {' '}
                                    <IconButton
                                      onClick={() =>
                                        removeFilterHandler(
                                          searchFilter[0]
                                        )
                                      }
                                    >
                                      {' '}
                                      <Icon
                                        color="red"
                                        path={mdiCloseCircleOutline}
                                        size={1}
                                      // className={classes.cancelFilter}
                                      // className={classes.icon}
                                      />{' '}
                                    </IconButton>{' '}
                                    <span>
                                      {' '}
                                      {props.filterLabelTranslator(
                                        searchFilter[0]
                                      )}{' '}
                                    </span>
                                    <span>
                                      {removeEmptyValueObject(
                                        searchFilter[1]
                                      )}
                                    </span>{' '}
                                  </Grid>
                                )
                              );
                            }
                          )}
                        </Grid>
                      </Paper>
                    </Popper>
                  ) : null}
                </StyledTableCell>
              );
            })}
            {props.haveAction && <StyledTableCell></StyledTableCell>}
          </TableRow>
        </ClickAwayListener>
      </TableHead>
      {/* </Table>
          </TableContainer>
        </Grid>
      </Grid> */}
    </StylesProvider>
  );
};
export default HeaderBuilder;
